export default __webpack_public_path__ + "static/media/linkedIn.c5de5cb1.png";